// Vuex.
import { mapActions } from 'vuex'

// Moment.
import moment from 'moment'

// Mixins.
import { repository, error, unmask, data } from '@/mixins'

// Enums.
import modeloCertidao from '@/enums/cadastro/cidadao/modeloCertidao'

export default {
    mixins: [ repository, error, unmask, data ],
    data: () => ({
        repositories: {
            cidadao: null,
        },
        form: {
            cidadao: {
                termosInvalidos: [],
                dataAtual: '',
                identificacao: {
                    motivosDuplicidadeCpf: [],
                    preferenciasNome: [],
                    sexos: [],
                    identidadesGenero: [],
                    estadosCivis: [],
                    situacoesFamiliaresConjugais: [],
                    racasCores: [],
                    etniasIndigenas: [],
                    tiposSanguineo: [],
                    deficiencias: [],
                    mobilidadesReduzidas: [],
                    locaisNascimento: [],
                    paises: [],
                    nacionalidades: [],
                    escolaridades: [],
                },
                endereco: {
                    cep: '',
                    semNumero: false,
                    bairroNome: '',
                    municipioNome: '',
                    estadoUf: '',
                    ibge: '',
                    paisNome: '',
                    zonas: [],
                    tempoHabitacao: '',
                },
                documentos: {
                    carteiraIdentidade: {
                        estados: [],
                    },
                    carteiraNacionalHabilitacao: {
                        categorias: [],
                        estados: [],
                    },
                    carteiraTrabalho: {
                        estados: [],
                    },
                    certidao: {
                        tipos: [],
                        modelos: [],
                        estados: [],
                        estadoId: null,
                    },
                },
                questionarioSaude: {
                    fatoresRisco: [],
                    alergiaCriticidades: [],
                    alergiaTipos: []
                }
            },
        },
        model: {
            cidadao: {
                id: null,
                cadastroSimplificado: false,
                semDocumentos: false,
                cns: '',
                cpf: '',
                cpfNaoPertenceAoCidadao: false,
                motivoDuplicidadeCpfId: null,
                motivoDuplicidadeCpfOutro: '',
                nome: '',
                nomeSocial: '',
                preferenciaNomeId: null,
                dataNascimento: null,
                idade: null,
                sexoId: null,
                identidadeGeneroId: null,
                estadoCivilId: null,
                conjuge: '',
                situacaoFamiliarConjugalId: null,
                racaCorId: null,
                etniaIndigenaId: null,
                tipoSanguineoId: null,
                deficienciaId: null,
                deficienciaOutro: '',
                mobilidadeReduzidaId: null,
                desconheceNomeMae: false,
                desconheceNomePai: false,
                nomeMae: '',
                nomePai: '',
                localNascimentoId: null,
                paisNascimentoId: null,
                nacionalidadeId: null,
                portariaNaturalizacao: '',
                dataNaturalizacao: null,
                estadoNascimentoId: null,
                municipioNascimento: null,
                frequentaEscola: false,
                escolaridadeId: null,
                telefones: [],
                conveniosMedicos: [],
                fatoresRisco: [],
                fatorRiscoOutro: '',
                alergias: [],
                medicamentosUsoContinuo: [],
                dataEntradaDomicilio: null,
                domicilio: {
                    endereco: {
                        logradouro: null,
                        numero: null,
                        complemento: '',
                        referencia: '',
                        loteamento: null,
                        zonaId: null,
                        latitude: '',
                        longitude: '',
                    }
                },
                documentos: {
                    carteiraIdentidade: {
                        id: null,
                        numero: '',
                        estadoId: null,
                        orgaoEmissor: '',
                        dataEmissao: null,
                    },
                    carteiraNacionalHabilitacao: {
                        id: null,
                        numero: '',
                        dataEmissao: null,
                        dataValidade: null,
                        estadoId: null,
                        categoriaId: null,
                    },
                    carteiraTrabalho: {
                        id: null,
                        numero: '',
                        serie: '',
                        dataEmissao: null,
                        estadoId: null,
                        nisPisPasep: '',
                    },
                    estrangeiroEntradaBrasil: {
                        id: null,
                        rne: '',
                        dataEntrada: null,
                    },
                    tituloEleitor: {
                        id: null,
                        numero: '',
                        zona: '',
                        secao: '',
                    },
                    certidao: {
                        id: null,
                        tipoId: null,
                        modeloId: null,
                        numero: '',
                        cartorioNome: '',
                        livro: '',
                        folha: '',
                        dataEmissao: null,
                        municipio: null,
                        cartorioCodigo: '',
                    },
                    outro: {
                        protocoloCross: null
                    },
                },
                pesoId: null,
                sexo: [],
            },
        },
        enums: { modeloCertidao },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        synchronizeCidadaoSearchData(data) {

            this.model.cidadao.cpf = data.cpf
            this.model.cidadao.nome = data.nome
            this.model.cidadao.dataNascimento = data.dataNascimento
            this.model.cidadao.desconheceNomeMae = data.desconheceNomeMae
            this.model.cidadao.nomeMae = data.nomeMae
        },
        loadCidadaoData(cidadao) {

            this.setLoading()

            const request = cidadao
                ? this.repositories.cidadao.edit(cidadao.id)
                : this.repositories.cidadao.create()

            request
                .then(({ data }) => {

                    if (data.model) {

                        data.model.id = cidadao.id
                    }

                    this.setCidadaoData(data.form, data.model || null)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadCidadaoDataIntegracaoCns(model) {

            this.setLoading()

            this.repositories.cidadao.create()
                .then(({ data }) => {
                    this.setCidadaoData(data.form, model || null)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setCidadaoData(form, model) {

            this.form.cidadao.termosInvalidos = form.termosInvalidos
            this.form.cidadao.dataAtual = form.dataAtual

            this.form.cidadao.identificacao.motivosDuplicidadeCpf = form.identificacao.motivosDuplicidadeCpf
            this.form.cidadao.identificacao.preferenciasNome = form.identificacao.preferenciasNome
            this.form.cidadao.identificacao.sexos = form.identificacao.sexos
            this.form.cidadao.identificacao.identidadesGenero = form.identificacao.identidadesGenero
            this.form.cidadao.identificacao.estadosCivis = form.identificacao.estadosCivis

            this.form.cidadao.identificacao.situacoesFamiliaresConjugais =
                form.identificacao.situacoesFamiliaresConjugais

            this.form.cidadao.identificacao.racasCores = form.identificacao.racasCores
            this.form.cidadao.identificacao.etniasIndigenas = form.identificacao.etniasIndigenas
            this.form.cidadao.identificacao.tiposSanguineo = form.identificacao.tiposSanguineo
            this.form.cidadao.identificacao.deficiencias = form.identificacao.deficiencias
            this.form.cidadao.identificacao.mobilidadesReduzidas = form.identificacao.mobilidadesReduzidas
            this.form.cidadao.identificacao.locaisNascimento = form.identificacao.locaisNascimento
            this.form.cidadao.identificacao.paises = form.identificacao.paises
            this.form.cidadao.identificacao.nacionalidades = form.identificacao.nacionalidades
            this.form.cidadao.identificacao.escolaridades = form.identificacao.escolaridades

            this.form.cidadao.endereco.zonas = form.endereco.zonas

            this.form.cidadao.documentos.carteiraIdentidade.estados = form.documentos.estados

            this.form.cidadao.documentos.carteiraNacionalHabilitacao.categorias =
                form.documentos.carteiraNacionalHabilitacao.categorias

            this.form.cidadao.documentos.carteiraNacionalHabilitacao.estados = form.documentos.estados

            this.form.cidadao.documentos.carteiraTrabalho.estados = form.documentos.estados

            this.form.cidadao.documentos.certidao.tipos = form.documentos.certidao.tipos
            this.form.cidadao.documentos.certidao.modelos = form.documentos.certidao.modelos
            this.form.cidadao.documentos.certidao.estados = form.documentos.estados

            Object.assign(this.form.cidadao.questionarioSaude, form.questionarioSaude)

            if (!model) return

            this.model.cidadao.id = model.id
            this.model.cidadao.cns = model.cns
            this.model.cidadao.cpf = model.cpf

            if (model.cpfNaoPertenceAoCidadao === null && !this.model.cidadao.cadastroSimplificado) {

                this.model.cidadao.cpfNaoPertenceAoCidadao = false
            }
            else {

                this.model.cidadao.cpfNaoPertenceAoCidadao = model.cpfNaoPertenceAoCidadao
            }

            this.model.cidadao.motivoDuplicidadeCpfId = model.motivoDuplicidadeCpfId
            this.model.cidadao.motivoDuplicidadeCpfOutro = model.motivoDuplicidadeCpfOutro
            this.model.cidadao.nome = model.nome
            this.model.cidadao.nomeSocial = model.nomeSocial

            this.$nextTick()
                .then(() => {

                    this.model.cidadao.preferenciaNomeId = model.preferenciaNomeId

                    this.model.cidadao.dataNascimento = model.dataNascimento
                        ? moment(model.dataNascimento).toDate()
                        : null

                    this.model.cidadao.dataObito = model.dataObito
                        ? moment(model.dataObito).toDate()
                        : null

                    this.model.cidadao.idade = model.idade
                    this.model.cidadao.sexoId = model.sexoId
                    this.model.cidadao.identidadeGeneroId = model.identidadeGeneroId
                    this.model.cidadao.estadoCivilId = model.estadoCivilId
                    this.model.cidadao.conjuge = model.conjuge
                    this.model.cidadao.situacaoFamiliarConjugalId = model.situacaoFamiliarConjugalId
                    this.model.cidadao.racaCorId = model.racaCorId
                    this.model.cidadao.tipoSanguineoId = model.tipoSanguineoId
                    this.model.cidadao.deficienciaId = model.deficienciaId
                    this.model.cidadao.deficienciaOutro = model.deficienciaOutro
                    this.model.cidadao.mobilidadeReduzidaId = model.mobilidadeReduzidaId
                    this.model.cidadao.desconheceNomeMae = model.desconheceNomeMae
                    this.model.cidadao.desconheceNomePai = model.desconheceNomePai
                    this.model.cidadao.nomeMae = model.nomeMae
                    this.model.cidadao.nomePai = model.nomePai
                    this.model.cidadao.localNascimentoId = model.localNascimentoId
                    this.model.cidadao.pesoId = model.pesoId
                    this.model.cidadao.sexo = model.sexo

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.cidadao.paisNascimentoId = model.paisNascimentoId

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.cidadao.nacionalidadeId = model.nacionalidadeId
                    this.model.cidadao.portariaNaturalizacao = model.portariaNaturalizacao

                    this.model.cidadao.dataNaturalizacao = model.dataNaturalizacao
                        ? moment(model.dataNaturalizacao).toDate() : null

                    this.model.cidadao.etniaIndigenaId = model.etniaIndigenaId
                    this.model.cidadao.estadoNascimentoId = model.estadoNascimentoId

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.cidadao.municipioNascimento = model.municipioNascimento

                    if (model.frequentaEscola === null && !this.model.cidadao.cadastroSimplificado) {

                        this.model.cidadao.frequentaEscola = false
                    }
                    else {

                        this.model.cidadao.frequentaEscola = model.frequentaEscola
                    }

                    this.model.cidadao.escolaridadeId = model.escolaridadeId
                    this.model.cidadao.telefones = model.telefones
                    this.model.cidadao.conveniosMedicos = model.conveniosMedicos
                    this.form.cidadao.endereco.cep = form.endereco.cep

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.cidadao.domicilio.endereco.logradouro = model.domicilio.endereco.logradouro
                    this.form.cidadao.endereco.semNumero = form.endereco.semNumero
                    this.model.cidadao.domicilio.endereco.numero = model.domicilio.endereco.numero
                    this.model.cidadao.domicilio.endereco.complemento = model.domicilio.endereco.complemento
                    this.model.cidadao.domicilio.endereco.referencia = model.domicilio.endereco.referencia
                    this.model.cidadao.domicilio.endereco.loteamento = model.domicilio.endereco.loteamento
                    this.model.cidadao.domicilio.endereco.zonaId = model.domicilio.endereco.zonaId
                    this.model.cidadao.domicilio.endereco.latitude = model.domicilio.endereco.latitude
                    this.model.cidadao.domicilio.endereco.longitude = model.domicilio.endereco.longitude

                    if (model.dataEntradaDomicilio) {

                        this.model.cidadao.dataEntradaDomicilio = moment(model.dataEntradaDomicilio).toDate()
                    }

                    Object.assign(
                        this.model.cidadao.documentos.tituloEleitor,
                        model.documentos.tituloEleitor
                    )

                    Object.assign(
                        this.model.cidadao.documentos.carteiraIdentidade,
                        model.documentos.carteiraIdentidade
                    )

                    this.model.cidadao.documentos.certidao.id = model.documentos.certidao.id
                    this.model.cidadao.documentos.certidao.tipoId = model.documentos.certidao.tipoId

                    if (model.documentos.certidao.modeloId) {

                        this.model.cidadao.documentos.certidao.modeloId = model.documentos.certidao.modeloId
                    }

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.cidadao.documentos.certidao.numero = model.documentos.certidao.numero
                    this.model.cidadao.documentos.certidao.cartorioNome = model.documentos.certidao.cartorioNome
                    this.model.cidadao.documentos.certidao.livro = model.documentos.certidao.livro
                    this.model.cidadao.documentos.certidao.folha = model.documentos.certidao.folha
                    this.model.cidadao.documentos.certidao.dataEmissao = model.documentos.certidao.dataEmissao
                    this.form.cidadao.documentos.certidao.estadoId = form.documentos.certidao.estadoId

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.cidadao.documentos.certidao.municipio = model.documentos.certidao.municipio
                    this.model.cidadao.documentos.certidao.cartorioCodigo = model.documentos.certidao.cartorioCodigo

                    Object.assign(
                        this.model.cidadao.documentos.carteiraTrabalho,
                        model.documentos.carteiraTrabalho
                    )

                    this.model.cidadao.documentos.carteiraNacionalHabilitacao.id = model.documentos.
                        carteiraNacionalHabilitacao.id

                    this.model.cidadao.documentos.carteiraNacionalHabilitacao.numero = model.documentos.
                        carteiraNacionalHabilitacao.numero

                    this.model.cidadao.documentos.carteiraNacionalHabilitacao.dataEmissao = model.documentos.
                        carteiraNacionalHabilitacao.dataEmissao

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.cidadao.documentos.carteiraNacionalHabilitacao.dataValidade = model.documentos.
                        carteiraNacionalHabilitacao.dataValidade

                    this.model.cidadao.documentos.carteiraNacionalHabilitacao.estadoId = model.documentos.
                        carteiraNacionalHabilitacao.estadoId

                    this.model.cidadao.documentos.carteiraNacionalHabilitacao.categoriaId = model.documentos.
                        carteiraNacionalHabilitacao.categoriaId

                    this.model.cidadao.documentos.outro.protocoloCross = model.documentos.outro.protocoloCross

                    Object.assign(
                        this.model.cidadao.documentos.estrangeiroEntradaBrasil,
                        model.documentos.estrangeiroEntradaBrasil
                    )

                    this.model.cidadao.fatoresRisco = model.fatoresRisco
                    this.model.cidadao.fatorRiscoOutro = model.fatorRiscoOutro

                    this.model.cidadao.alergias = model.alergias.map((alergia, index) => {

                        alergia.index = index

                        return alergia
                    })

                    this.model.cidadao.medicamentosUsoContinuo = model.medicamentosUsoContinuo
                })
        },
        prepareCidadaoData() {

            const cidadao = this.clone(this.model.cidadao)

            cidadao.cns = cidadao.cns ? this.unMaskCns(cidadao.cns) : null
            cidadao.cpf = cidadao.cpf ? this.unMaskCpf(cidadao.cpf) : null
            cidadao.dataNascimento = this.getFormatedDate(cidadao.dataNascimento)

            cidadao.municipioNascimentoId = cidadao.municipioNascimento
                ? cidadao.municipioNascimento.id
                : null

            delete cidadao.municipioNascimento

            cidadao.dataNaturalizacao = this.getFormatedDate(cidadao.dataNaturalizacao)

            cidadao.telefones = cidadao.telefones.map(telefone => {

                telefone.numero = this.unMaskPhone(telefone.numero)

                return telefone
            })

            cidadao.conveniosMedicos = cidadao.conveniosMedicos.map(cm => cm.id)

            cidadao.domicilio.endereco.logradouroId = cidadao.domicilio.endereco.logradouro
                ? cidadao.domicilio.endereco.logradouro.id
                : null

            delete cidadao.domicilio.endereco.logradouro

            cidadao.domicilio.endereco.loteamentoId = cidadao.domicilio.endereco.loteamento
                ? cidadao.domicilio.endereco.loteamento.id
                : null

            delete cidadao.domicilio.endereco.loteamento

            cidadao.dataEntradaDomicilio = this.getFormatedDate(cidadao.dataEntradaDomicilio)

            cidadao.documentos.carteiraIdentidade.dataEmissao = this.getFormatedDate(
                cidadao.documentos.carteiraIdentidade.dataEmissao
            )

            cidadao.documentos.carteiraNacionalHabilitacao.dataEmissao = this.getFormatedDate(
                cidadao.documentos.carteiraNacionalHabilitacao.dataEmissao
            )

            cidadao.documentos.carteiraNacionalHabilitacao.dataValidade = this.getFormatedDate(
                cidadao.documentos.carteiraNacionalHabilitacao.dataValidade
            )

            cidadao.documentos.carteiraTrabalho.dataEmissao = this.getFormatedDate(
                cidadao.documentos.carteiraTrabalho.dataEmissao
            )

            cidadao.documentos.estrangeiroEntradaBrasil.dataEntrada = this.getFormatedDate(
                cidadao.documentos.estrangeiroEntradaBrasil.dataEntrada
            )

            cidadao.documentos.certidao.dataEmissao = this.getFormatedDate(
                cidadao.documentos.certidao.dataEmissao
            )

            if (cidadao.documentos.certidao.modeloId === this.enums.modeloCertidao.NOVO) {

                cidadao.documentos.certidao.numero = this.unMaskNumeroCertidao(
                    cidadao.documentos.certidao.numero
                )
            }

            cidadao.documentos.certidao.municipioId = cidadao.documentos.certidao.municipio
                ? cidadao.documentos.certidao.municipio.id
                : null

            delete cidadao.documentos.certidao.municipio

            cidadao.alergias = cidadao.alergias.map(item => ({
                alergiaId: item.alergia.id,
                criticidadeId: item.alergia.criticidade.id,
                reacoesObservacoes: item.alergia.reacoesObservacoes,
                cidId: item.alergia.cid ? item.alergia.cid.id : null ,
            }))

            cidadao.medicamentosUsoContinuo = cidadao.medicamentosUsoContinuo.map(item => {
                return {
                    medicamentoId: item.medicamento.id,
                }
            })

            return cidadao
        },
    },
    created() {

        this.repositories.cidadao = this.getConectaSusRepository('cadastro.sujeitoAtencao.cidadao')
    }
}